import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_CONCILIACION_REGLAS;

function filter(param = {}) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function fields() {
  return wsService.make_get_request(section + "/fields");
}

export const conciliacionReglaService = {
  section,
  filter,
  create,
  update,
  remove,
  fields,
};
